// import { getEnvs } from '@/shared/utils';
// const { VITE_BUCKET_BASE } = getEnvs();
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import {
  ROUTER_PATHS,
  TABLE_CONSTANTS,
  emptyCellOneLevel,
  formatDate,
  hasAllPermissions,
  useCheckPermissions,
  useTableServerSideFiltering,
} from "@/shared";
import { useFetchProductos } from "@/shared/actions/erp";
import {
  GeneralTable,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import { useTableFilter } from "@/shared/hooks/useTableFilter";
import { IDataProducto } from "@/shared/interfaces";
import { useUiConfirmModalStore } from "@/store/ui";
import { PermissionsEnum } from "@/auth/interfaces";

export type ServiceProfilePageProps = {};

const ServiceProfilePage: React.FC<ServiceProfilePageProps> = () => {
  useCheckPermissions(PermissionsEnum.asociar_service_profile);

  const returnUrlServiceProfilePage = ROUTER_PATHS.configuracionRED.serviceProfileNav;

  const navigate = useNavigate();

  ///* global state
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );

  // const deleteIpv4 = useDeleteIpv4();

  ///* table
  const {
    pagination,
    setPagination
  } = useTableFilter();
  const { filterObject, columnFilters, setColumnFilters } =
      useTableServerSideFiltering();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: ProductoPagingRes,
    isLoading,
    isRefetching,
  } = useFetchProductos({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      es_ont: true,
      ...filterObject,
    },
  });

  ///* handlers

  const onEdit = (producto: IDataProducto) => {
    setConfirmDialog({
      isOpen: true,
      title: "Editar Producto",
      subtitle: "¿Está seguro que desea editar este producto?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        navigate(`${returnUrlServiceProfilePage}/editar/${producto.id_producto}`);
      },
    });
  };

  // const onDelete = (producto: IDataProducto) => {
  //   setConfirmDialog({
  //     isOpen: true,
  //     title: "Eliminar Producto",
  //     subtitle: "¿Está seguro que desea eliminar este producto?",
  //     onConfirm: () => {
  //       setConfirmDialogIsOpen(false);
  //       // deleteIpv4.mutate(ipv4.id_ipv4!);
  //     },
  //   });
  // };

  const columns = useMemo<MRT_ColumnDef<IDataProducto>[]>(
    () => [
      {
        accessorKey: "codigo",
        header: "Código",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "codigo"),
      },
      {
        accessorKey: "descripcion",
        header: "Nombre",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "descripcion"),
      },
      {
        accessorKey: "service_profile",
        header: "Service Profile",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "service_profile"),
      },
      {
        accessorKey: "fecha_creacion",
        header: "Fecha Creación",
        enableColumnFilter:false,
        size: 180,
        Cell: ({ row }) => formatDate(row.original?.fecha_creacion||""),
      },
      {
        accessorKey: "fecha_modificacion",
        header: "Fecha Actualización",
        enableColumnFilter:false,
        size: 180,
        Cell: ({ row }) => formatDate(row.original?.fecha_modificacion||""),
      },
    ],
    []
  );

  //CUSTOM HOOKS

  // const { fileInputRef: importOLTs, handleImportarOLT } = useUploadFile();

  return (
    <SingleTableBoxScene
      title="Asociar Service Profile"
      
      //excel
      // enableUploadFile={true}
      // enableDownloadFile={true}
      // fileInputRef={importOLTs}
      // importationName={"Subir OLTs"}
      // handleFileUpload={handleImportarOLT}
      // importationsQuantity={1}
      // urlDownloadPlantilla={
      //   "/"+VITE_BUCKET_BASE+plantillaExcelENUM.PLANTILLA_OLT
      // }
      // urlDownloadNameExcel={"plantilla_olt"}
    >

      <GeneralTable<IDataProducto>
        columns={columns}
        data={ProductoPagingRes?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={ProductoPagingRes?.data?.count}
        ///* filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // actions ========
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.asociar_service_profile,
        ])}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        canEdit={hasAllPermissions([
          PermissionsEnum.asociar_service_profile,
        ])}
        onEdit={onEdit}
        canDelete={false}
        // onDelete={onDelete}
      />
    </SingleTableBoxScene>
  );
};

export default ServiceProfilePage;
